import { ApolloError, useMutation } from '@apollo/client';
import { graphql } from '../gql';
import { useMemo } from 'react';

const DELETE_EXCESS_TOWER_LAYER_MUTATION = graphql(`
  mutation deleteExcessTowerLayer($position: Int!, $quoteUuid: String!) {
    deleteExcessTowerLayer(position: $position, quoteUuid: $quoteUuid) {
      result
      relationshipsDeleted
      nodesDeleted
      description
    }
  }
`);

export function useDeleteExcessTowerLayer() {
  const [deleteExcessTowerLayer, { data, loading, error, reset }] = useMutation(
    DELETE_EXCESS_TOWER_LAYER_MUTATION,
    {}
  );

  const result = data?.deleteExcessTowerLayer?.result;

  // TODO: Remove this when https://convergeins.atlassian.net/browse/CON-3242 is fixed
  const newError = useMemo((): Error | void => {
    if (error) {
      return error;
    }

    if (result === 'FAIL') {
      return new ApolloError({
        errorMessage: 'Failed to delete excess tower layer. Does it exist?',
      });
    }
  }, [result, error]);

  return {
    data,
    deleteExcessTowerLayer: async (
      ...args: Parameters<typeof deleteExcessTowerLayer>
    ) => {
      const response = await deleteExcessTowerLayer(...args);

      if (response.data?.deleteExcessTowerLayer.result === 'FAIL') {
        throw new ApolloError({
          errorMessage: 'Failed to delete excess tower layer. Does it exist?',
        });
      }

      return response;
    },
    loading,
    error: newError,
    reset,
  };
}
